import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { UploadPhoto } from "./UploadPhoto";
import { PhotoRow } from "./PhotoRow";

export const PhotosTab = () => {
  const [photos, setPhotos] = useState(null);
  const [cats, setCats] = useState([]);

  const load = useCallback(() => api.get("/admin/photos").then((r) => setPhotos(r.data)).catch((e) => toast.error(errorText(e))), []);
  useEffect(() => { load(); api.get("/categories").then((r) => setCats(r.data)); }, [load]);

  const update = async (id, changes) => {
    try {
      const { data } = await api.patch(`/admin/photos/${id}`, changes);
      setPhotos((ps) => ps.map((p) => (p.id === id ? data : p)));
      toast.success("Guardado");
    } catch (e) { toast.error(errorText(e)); }
  };

  const move = async (idx, dir) => {
    const next = [...photos];
    const j = idx + dir;
    if (j < 0 || j >= next.length) return;
    [next[idx], next[j]] = [next[j], next[idx]];
    setPhotos(next);
    await api.post("/admin/photos/reorder", { ids: next.map((p) => p.id) }).catch((e) => toast.error(errorText(e)));
  };

  const remove = async (id) => {
    try { await api.delete(`/admin/photos/${id}`); setPhotos((ps) => ps.filter((p) => p.id !== id)); toast.success("Foto eliminada"); }
    catch (e) { toast.error(errorText(e)); }
  };

  return (
    <div className="space-y-6">
      <UploadPhoto cats={cats} onUploaded={load} />
      <div>
        <p className="text-sm text-ink/60 mb-3">El orden de esta lista es el orden del catálogo. "En inicio" muestra la foto en la página principal y la categoría decide en qué página de servicio aparece.</p>
        {!photos ? <Loader2 className="w-5 h-5 animate-spin text-granate" /> : (
          <div className="space-y-3" data-testid="admin-photos-list">
            {photos.map((p, i) => (
              <PhotoRow key={p.id} p={p} cats={cats} first={i === 0} last={i === photos.length - 1}
                onMove={(d) => move(i, d)} onUpdate={(c) => update(p.id, c)} onDelete={() => remove(p.id)} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
